function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M274.41 65.75l-26.47 22.76-28.89 35.4L215 170H33l.7-43.56L19.26 96.1 0 75.87V20.23l28.89-10.12 4.81 35.41h24.08L67.4 0l28.89 5.05v35.41h28.88l4.82-30.35h24.07l4.81 40.47h19.26l14.44-40.47 24.07 5.06v30.35h24.07V10.11h28.89l4.81 55.64z",
  fill: "#8585FF"
});

function SvgTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 275 170",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjc1IDE3MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMjc0LjQxIDY1Ljc1bC0yNi40NyAyMi43Ni0yOC44OSAzNS40TDIxNSAxNzBIMzNsLjctNDMuNTZMMTkuMjYgOTYuMSAwIDc1Ljg3VjIwLjIzbDI4Ljg5LTEwLjEyIDQuODEgMzUuNDFoMjQuMDhMNjcuNCAwbDI4Ljg5IDUuMDV2MzUuNDFoMjguODhsNC44Mi0zMC4zNWgyNC4wN2w0LjgxIDQwLjQ3aDE5LjI2bDE0LjQ0LTQwLjQ3IDI0LjA3IDUuMDZ2MzAuMzVoMjQuMDdWMTAuMTFoMjguODlsNC44MSA1NS42NHoiIGZpbGw9IiM4NTg1RkYiLz4KPC9zdmc+";
export { SvgTop as ReactComponent };